export default __webpack_public_path__ + "static/media/click2.877dd4bd.aac";